import React from "react";

function ViewAverageStarReview({ PD_ID = 0, reviewValue = 0 }) {
  const starShapes = {
    1: [{ g: "translate(15,15) scale(0.6)", polygons: ["translate(0,0)"] }],
    2: [
      {
        g: "translate(15,15) scale(0.5)",
        polygons: ["translate(-7,-7)", "translate(7,7)"],
      },
    ],
    3: [
      {
        g: "translate(15,15) scale(0.4)",
        polygons: ["translate(0,-10)", "translate(-10,7)", "translate(10,7)"],
      },
    ],
    4: [
      {
        g: "translate(15,15) scale(0.4)",
        polygons: [
          "translate(-10,-10)",
          "translate(10,-10)",
          "translate(10,10)",
          "translate(-10,10)",
        ],
      },
    ],
    5: [
      {
        g: "translate(15,15) scale(0.4)",
        polygons: [
          "translate(0,-14)",
          "translate(-14,-3)",
          "translate(14,-3)",
          "translate(8,13)",
          "translate(-8,13)",
        ],
      },
    ],
  };

  const getFillPercentage = (star) => {
    if (reviewValue >= star) return 100;
    if (reviewValue + 1 > star) return (reviewValue % 1) * 100;
    return 0;
  };

  return (
    <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
      {[1, 2, 3, 4, 5].map((star) => {
        const fillPercent = getFillPercentage(star);
        const gradientId = `avg-${PD_ID}-${star}`;

        return (
          <svg
            key={star}
            width="40"
            height="40"
            viewBox="0 0 30 30"
            style={{ overflow: "visible" }}
          >
            <defs>
              <linearGradient id={gradientId} x1="0%" x2="100%" y1="0%" y2="0%">
                <stop offset={`${fillPercent}%`} stopColor="#fc9700" />
                <stop offset={`${fillPercent}%`} stopColor="white" />
              </linearGradient>
            </defs>

            <circle
              cx="15"
              cy="15"
              r="13"
              stroke={fillPercent > 0 ? "#cc4e00" : "#cc4e00"}
              strokeWidth="2"
              fill={`url(#${gradientId})`}
            />

            {starShapes[star].map((group, gi) => (
              <g key={gi} transform={group.g}>
                {group.polygons.map((transform, pi) => (
                  <polygon
                    key={pi}
                    points="0,-10 2,-4 8,-4 3,0 5,6 0,2 -5,6 -3,0 -8,-4 -2,-4"
                    fill={fillPercent > 0 ? "#cc4e00" : "#cc4e00"}
                    stroke={fillPercent > 0 ? "#cc4e00" : "#cc4e00"}
                    transform={transform}
                  />
                ))}
              </g>
            ))}
          </svg>
        );
      })}
    </div>
  );
}

export default ViewAverageStarReview;
